<template>
  <div
    class="table-grid-tr"
    ref="$el"
    :style="{ 'grid-template-columns': widthColumns }"
    @mouseover="onLocalMouseover"
    @mouseout="onLocalMouseout"
  >
    <slot :hover="isMouseAtRow"></slot>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType, ref } from "vue";
const $el = ref<HTMLElement>();

const props = defineProps({
  /**
   * Массив с ширинами колонок
   */
  columns: { type: Array as PropType<string[]>, default: () => [] },
});

const isMouseAtRow = ref(false);

const onLocalMouseover = () => {
  isMouseAtRow.value = true;
};

const onLocalMouseout = () => {
  isMouseAtRow.value = false;
};
/**
 * Стили
 */
let widthColumns = computed(() => {
  if (props.columns.length) return props.columns.join(" ");
  return "repeat(auto-fill, minmax(6.25rem, 1fr))";
});
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
